import { contentSections } from '@/mocks/sections';
import { resolveTone, toneStyles } from '@/utils/tone';

export default function SectionsSection() {
  return (
    <section id="sections" className="relative bg-foreground-950 py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 bg-grain opacity-40" aria-hidden="true" />
      <div className="relative w-full px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-label font-medium tracking-[0.2em] uppercase text-accent-300">
            <i className="ri-stack-line" aria-hidden="true" />
            内容板块
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
            六大内容板块，对应六种阅读目的
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200/80">
            全站内容按生产方式与篇幅分成六个板块。想快速了解事件进展看独家爆料，想弄清来龙去脉看深度调查，
            遇到具体麻烦则可以直接翻维权指南。
          </p>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {contentSections.map((section, index) => {
            const tone = toneStyles[resolveTone(section.tone)];
            return (
              <article
                key={section.slug}
                className="flex flex-col gap-4 rounded-lg border border-background-50/12 bg-background-50/[0.04] p-5 md:p-6 transition-colors hover:bg-background-50/[0.07]"
              >
                <div className="flex items-center justify-between">
                  <span className={`w-11 h-11 rounded-lg flex items-center justify-center ${tone.iconBox}`}>
                    <i className={`${section.icon} text-xl`} aria-hidden="true" />
                  </span>
                  <span className="font-heading text-2xl font-bold text-background-50/25">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                </div>
                <h3 className="font-heading text-lg font-bold text-background-50">{section.name}</h3>
                <p className="text-sm leading-relaxed text-background-200/75">{section.desc}</p>
                <div className="mt-auto pt-3 flex items-center gap-2 text-xs font-label text-accent-300">
                  <i className="ri-time-line" aria-hidden="true" />
                  {section.feature}
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}